export default "__VITE_ASSET__B0OiA92i__"